/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Address } from './Address';
import {
    AddressFromJSON,
    AddressFromJSONTyped,
    AddressToJSON,
    AddressToJSONTyped,
} from './Address';
import type { Property } from './Property';
import {
    PropertyFromJSON,
    PropertyFromJSONTyped,
    PropertyToJSON,
    PropertyToJSONTyped,
} from './Property';
import type { Link } from './Link';
import {
    LinkFromJSON,
    LinkFromJSONTyped,
    LinkToJSON,
    LinkToJSONTyped,
} from './Link';

/**
 * 
 * @export
 * @interface Location
 */
export interface Location {
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    title?: string;
    /**
     * 
     * @type {Array<Address>}
     * @memberof Location
     */
    addresses?: Array<Address>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Location
     */
    emailAddresses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Location
     */
    telephoneNumbers?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Location
     */
    urls?: Array<string>;
    /**
     * 
     * @type {Set<Property>}
     * @memberof Location
     */
    props?: Set<Property>;
    /**
     * 
     * @type {Array<Link>}
     * @memberof Location
     */
    links?: Array<Link>;
    /**
     * 
     * @type {string}
     * @memberof Location
     */
    remarks?: string;
}

/**
 * Check if a given object implements the Location interface.
 */
export function instanceOfLocation(value: object): value is Location {
    return true;
}

export function LocationFromJSON(json: any): Location {
    return LocationFromJSONTyped(json, false);
}

export function LocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): Location {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
        'title': json['title'] == null ? undefined : json['title'],
        'addresses': json['addresses'] == null ? undefined : ((json['addresses'] as Array<any>).map(AddressFromJSON)),
        'emailAddresses': json['emailAddresses'] == null ? undefined : json['emailAddresses'],
        'telephoneNumbers': json['telephoneNumbers'] == null ? undefined : json['telephoneNumbers'],
        'urls': json['urls'] == null ? undefined : json['urls'],
        'props': json['props'] == null ? undefined : (new Set((json['props'] as Array<any>).map(PropertyFromJSON))),
        'links': json['links'] == null ? undefined : ((json['links'] as Array<any>).map(LinkFromJSON)),
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
    };
}

export function LocationToJSON(json: any): Location {
    return LocationToJSONTyped(json, false);
}

export function LocationToJSONTyped(value?: Location | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'uuid': value['uuid'],
        'title': value['title'],
        'addresses': value['addresses'] == null ? undefined : ((value['addresses'] as Array<any>).map(AddressToJSON)),
        'emailAddresses': value['emailAddresses'],
        'telephoneNumbers': value['telephoneNumbers'],
        'urls': value['urls'],
        'props': value['props'] == null ? undefined : (Array.from(value['props'] as Set<any>).map(PropertyToJSON)),
        'links': value['links'] == null ? undefined : ((value['links'] as Array<any>).map(LinkToJSON)),
        'remarks': value['remarks'],
    };
}

